// @flow

import type {
  Action,
} from 'fc-flow-types/redux'

// Action Types
import {
  FETCH_FARMS,
  FETCH_FIELDS,
  SELECT_FARM,
  SELECT_FIELD,
  BORDER_UPLOADED,
} from './constants'

export const fetchFarms = function (): Action<void> {
  return {
    type: FETCH_FARMS,
  }
}

export const fetchFields = function ({ farmId }: { farmId?: number }): Action<?number> {
  return {
    type: FETCH_FIELDS,
    payload: farmId,
  }
}

export const updateFarm = function (farmId: number): Action<void> {
  return {
    type: SELECT_FARM,
    payload: farmId,
  }
}

export const updateField = function (fieldId: number): Action<void> {
  return {
    type: SELECT_FIELD,
    payload: fieldId,
  }
}

export const borderUploaded = function (payload: Object): Action<void> {
  return {
    type: BORDER_UPLOADED,
    payload,
  }
}
